module.exports = __webpack_public_path__ + "static/media/PushtimargImage15.cd25b22f.jpg";